import React from 'react';
import LogoutConfirmationModal from './LogoutConfirmationModal';
import OnlineAlertModal from './OnlineAlertModal';
import SessionExpireMessageModal from './SessionExpireMessageModal';
import InternalServerErrorModal from './InternalServerError';
import ChangeTeamDataConfirmation from './ChangeTeamDataConfirmation';
import RemoteWipeModal from './RemoteWipeModal';
import UnSubmittedScanSessions from './UnSubmittedScanSessions';
import UnSavedCaseChanges from './UnSavedCaseChanges';
import StatusCode400 from './StatusCode400';
import StatusCode426 from './StatusCode426';
import StatusCode503 from './StatusCode503.js';
import DERTrackingModal from '../commonComponents/Modals/DERTrackingModal.js';
import AcmPushCaseStatusCode from './AcmPushCaseStatusCode.js';

const Modals = () => (
  <>
    <LogoutConfirmationModal />
    <OnlineAlertModal />
    <SessionExpireMessageModal />
    <InternalServerErrorModal />
    <ChangeTeamDataConfirmation />
    <UnSubmittedScanSessions />
    <UnSavedCaseChanges />
    <RemoteWipeModal />
    <StatusCode400 />
    <StatusCode426 />
    <StatusCode503 />
    <DERTrackingModal />
    <AcmPushCaseStatusCode />
  </>
);

export default Modals;
